<template>
  <div v-if="info" class="user-panel">
    <div :style="{ backgroundImage }" class="avatar"></div>
    <span>{{ name }}</span>
    <router-link to="/logout">
      <img title="Выход" src="@/assets/images/exit-icon.svg" />
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      info: 'user/profile',
      name: 'user/name',
      avatar: 'user/avatar',
    }),

    backgroundImage() {
      return 'url(' + this.avatar + ')';
    },
  },
};
</script>


<style lang="scss" scoped>
.user-panel {
  display: flex;
  align-items: center;
  justify-content: space-between;

  > * {
    margin: 0 5px;
  }

  .avatar {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
}
</style>
